import styled from "styled-components";
import { Link } from "react-router-dom";

export const Wrapper = styled.div`
    display: grid;
    padding: 5px;
    width: 30px;
    height: 30px;
    margin: auto;
    font-size: x-small;
    border-radius: 50%; 
    justify-content: center;
    background-color: ${({ IDonFile }) => (IDonFile ? "rgb(163, 223, 200)" : "rgb(228, 153, 150)")};
    transition: 1s;
    align-items: center;
    text-align: center;
    box-shadow: inset -6px -6px 8px rgb(119, 127, 126),rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    cursor: pointer;
`
export const Content = styled.div`
    
`
export const StyledLink = styled(Link)`
   
`